import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IWebMessage } from 'src/app/common/interfaces/webmessage-interface';
import { AbstractRtpConfigurationService } from '../abstraction/abstract.rtp-configuration.service';
import { IRtpTransactionalSettings } from '../../interfaces/configuration/rtp-transactional-settings.interface';

@Injectable({
  providedIn: 'root',
})
export class RtpConfigurationService extends AbstractRtpConfigurationService {
  private controller = `/manager/rtpconfiguration`;
  private urlGetRtpTransactionalSettings = `${environment.apiUrl}${this.controller}/rtptransactionalsettings`;
  private urlPostRtpTransactionalSettings = `${environment.apiUrl}${this.controller}/rtptransactionalsettings`;

  constructor(private http: HttpClient) {
    super();
  }

  getRtpTransactionalSettings(
    routingNumber: string
  ): Promise<IRtpTransactionalSettings | undefined> {
    return firstValueFrom(
      this.http.get<IRtpTransactionalSettings>(
        `${this.urlGetRtpTransactionalSettings}/${routingNumber}`
      )
    );
  }

  updateRtpTransactionalSettings(
    settings: IRtpTransactionalSettings
  ): Promise<IWebMessage | undefined> {
    return firstValueFrom(
      this.http.post<IWebMessage>(`${this.urlPostRtpTransactionalSettings}`, settings)
    );
  }
}
